import React, { FC } from 'react';

import HeaderMenu from 'images/header-menu.svg';

import { BlankButton } from '../BlankButton';

export const DrawerButton: FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => (
  <BlankButton type="button" data-testid="header-mobile-toggle-drawer" {...props}>
    <img alt="toggle-drawer" src={HeaderMenu} />
  </BlankButton>
);
